module.exports = __webpack_public_path__ + "fonts/Roboto-Light.3c37aa69.woff2";